export default __webpack_public_path__ + "static/media/Poppins-Medium.5dad75f3.svg";